import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CancelIcon from "@mui/icons-material/Cancel";

const baseStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95vw",
  maxHeight: "92vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: "0 8px 32px rgba(4,52,58,0.18)",
  p: 4,
  borderRadius: "16px",
};

export default function MuiModal({ open, setOpen, children, maxWidth }) {
  const style = { ...baseStyle, maxWidth: maxWidth || "1200px" };
  // const [open, setOpen] = React.useState(true);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEnforceFocus={true}
        disableAutoFocus={ true}
        // sx={{ maxWidth: '100vw'}}
        // sx={{ minWidth: '90%'}}
      >
        <Box sx={style}>
          {/* IMP: ANY COMMON CONTENT for the MODAL MUST BE ADDED HERE  */}

          {/* CLOSE / CANCEL BUTTON ON TOP RIGHT */}
          <CancelIcon
            color="success"
            sx={{ position: "absolute", top: 10, right: 10, cursor: "pointer" }}
            onClick={() => setOpen(false)}
          />
          {children}
          {/* <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
          </Typography> */}
        </Box>
      </Modal>
    </>
  );
}
